import React from 'react';
import { useSearchNotFoundLayout } from '../hooks/useSearchNotFoundLayout';

const SearchNotFoundLayoutContainer = ({ children }: any) => {
	const { blockClass, componentId } = useSearchNotFoundLayout();

	return (
		<div
			data-selection={componentId}
			className={`notFound--layout  notFound--layout--${blockClass} vtex-search-result-3-x-notFound--layout vtex-search-result-3-x-notFound--layout--${blockClass} flex flex-column flex-grow-1`}
		>
			{children}
		</div>
	);
};

export default SearchNotFoundLayoutContainer;
